import React from 'react';
import { FlexContainer, Icon, Label, useTimezone } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { StyledButton, StyledCredentialCard } from './Styles';

type Props = {
  image: React.ReactElement;
  name: string;
  expirationDate?: Date;
  issuanceDate?: Date;
  isSelected?: boolean;
  onClick(): void;
};

export const CredentialsCard = ({
  expirationDate,
  image,
  name,
  isSelected,
  onClick,
}: Props) => {
  const { t } = useTranslation();
  const { formatTimezone } = useTimezone();
  const now = new Date();
  const isActive = expirationDate ? expirationDate > now : true;

  const getStatus = () => {
    return (
      <FlexContainer columnGap="0.8">
        <Icon
          iconName={isActive ? 'CheckCircle' : 'XCircle'}
          color={isActive ? 'success400' : 'error400'}
          size="14"
        />
        <Label fontSize="10">{t(isActive ? 'Active' : 'Expired')}</Label>
      </FlexContainer>
    );
  };

  return (
    <StyledCredentialCard
      role="button"
      onClick={onClick}
      flexDirection="row"
      columnGap="0.6"
      $isSelected={isSelected}
      $isActive={isActive}
    >
      {React.cloneElement(image)}
      <FlexContainer flexDirection="column" justifyContent="space-between">
        <Label semibold>{name}</Label>
        <FlexContainer columnGap="1.2">
          {expirationDate && getStatus()}
          <Label fontSize="10">
            {expirationDate
              ? formatTimezone(expirationDate, 'DD/MM/YYYY')
              : t('No expiration')}
          </Label>
        </FlexContainer>
      </FlexContainer>
      <StyledButton variant="text" iconName="ListPlus" size="S" />
    </StyledCredentialCard>
  );
};
